const UNAUTHENTICATED_TAG = Symbol('UnauthenticatedError');

export interface UnauthenticatedError extends Error {
    [UNAUTHENTICATED_TAG]: true;
}

export function createUnauthenticatedError(): UnauthenticatedError {
    const error = new Error('Request suppressed — not authenticated') as UnauthenticatedError;
    error.name = 'UnauthenticatedError';
    error[UNAUTHENTICATED_TAG] = true;
    return error;
}

export function isUnauthenticatedError(error: unknown): error is UnauthenticatedError {
    return (
        error != null &&
        typeof error === 'object' &&
        UNAUTHENTICATED_TAG in error
    );
}
